import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import {
  ArticleOutlined,
  TextFields,
  Image,
  PictureAsPdf,
} from '@mui/icons-material'

interface EmptyStateProps {
  onCreateBlock: (type: 'text' | 'image' | 'pdf') => void
  disabled?: boolean
}

export function EmptyState({
  onCreateBlock,
  disabled = false,
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: 8,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          border: '2px dashed',
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <ArticleOutlined sx={{ color: 'text.disabled', fontSize: 28 }} />
      </Box>

      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        Add your first block
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Choose a content type below to start building
      </Typography>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="contained"
          startIcon={<TextFields />}
          disabled={disabled}
          onClick={() => onCreateBlock('text')}
        >
          Text
        </Button>
        <Button
          variant="contained"
          startIcon={<Image />}
          disabled={disabled}
          onClick={() => onCreateBlock('image')}
        >
          Image
        </Button>
        <Button
          variant="contained"
          startIcon={<PictureAsPdf />}
          disabled={disabled}
          onClick={() => onCreateBlock('pdf')}
        >
          PDF
        </Button>
      </Box>
    </Box>
  )
}

export default EmptyState
